<template>
  <div v-if="tableData">
    <updated-list-component
      :table-headers="tableHeader"
      :table-data="generatedTableData"
      @client-clicked="clientClicked($event)"
      @request-feedback="sendFeedbackRequest($event)"
      @open-review-tab="openReviewTab($event)"
      @open-needed-tab="openNeededTab($event)"
    />
  </div>
</template>

<script>
import UpdatedListComponent from '../../uiUtils/UpdatedListComponent.vue'
import {
  feedbackNeededProperties,
  feedbackProvidedProperties
} from '../../../utils/propertyUtils'
import { dateOfLastFeedback } from '../../../services/invite-service'
import colors from '../../../scss/_colors.scss'

export default {
  components: { UpdatedListComponent },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      required: false,
      default: function() {
        return {
          hideHeaders: false,
          hideActions: false
        }
      }
    }
  },

  data() {
    return {
      generatedTableData: [],
      tableHeader: [
        { text: '', value: 'name', width: '40%', sortable: false },
        // { text: '', value: 'name',  sortable: false },
        { text: 'Review', value: 'review', sortable: false, align: 'center' },
        {
          text: 'Needed',
          value: 'feedbackNeeded',
          sortable: false,
          align: 'center'
        },
        // { text: 'Provide', value: 'provideFeedback', sortable: false, align: 'center' },
        {
          text: 'Request Feedback',
          value: 'requestFeedback',
          sortable: false,
          align: 'center'
        }
      ]
    }
  },

  watch: {
    tableData() {
      this.generatedTableData = this.generateFeedbackData(this.tableData)
    }
  },
  mounted() {
    this.generatedTableData = this.generateFeedbackData(this.tableData)
  },
  methods: {
    generateFeedbackData(tableDataArray) {
      let responseData = []
      tableDataArray.map((item, index) => {
        const feedbackNeededPropertiesList = feedbackNeededProperties(
          item.homes,
          item.routes
        )

        item.feedback_provided = feedbackProvidedProperties(item.homes).length
        item.feedback_needed = feedbackNeededPropertiesList.length
        let rowObject = {}
        rowObject[0] = {
          type: 'avatar',
          text: item.name,
          class: 'textLeft hwayzTeal text-capitalize wide',
          data: { action: 'client-clicked', value: item }
        }
        rowObject[1] = {
          type: 'clickableText',
          text: item.feedback_provided,
          class: 'text-xs-center',
          data: { action: 'open-review-tab', value: item }
        }
        rowObject[2] = {
          type: 'clickableText',
          text: item.feedback_needed,
          class: 'text-xs-center',
          data: { action: 'open-needed-tab', value: item }
        }

        const isNeedToRequestFeedback = feedbackNeededPropertiesList.filter(
          home => {
            return !dateOfLastFeedback(home.feedback.feedbackRequested)
          }
        )

        if (item.feedback_needed) {
          rowObject[3] = {
            type:
              isNeedToRequestFeedback.length && item.feedback_needed
                ? 'clickableText'
                : 'text',
            text:
              isNeedToRequestFeedback.length && item.feedback_needed
                ? 'REQUEST'
                : 'REQUESTED',
            color: isNeedToRequestFeedback.length
              ? colors.hwayzBrandGold
              : colors.hwayzBrandBlue,
            data: {
              action: isNeedToRequestFeedback.length ? 'request-feedback' : '',
              value: item
            }
          }
        } else {
          rowObject[3] = {
            type: 'text',
            text: ''
          }
        }

        if (item.feedback_needed !== 0 || item.feedback_provided !== 0) {
          responseData.push(rowObject)
        }
      })
      return responseData
    },
    clientClicked(data) {
      this.$emit('client-clicked', data)
    },
    openReviewTab(data) {
      this.$emit('open-review-tab', data)
    },
    openNeededTab(data) {
      this.$emit('open-needed-tab', data)
    },
    sendFeedbackRequest(item) {
      const feedbackNeededPropertiesList = feedbackNeededProperties(
        item.homes,
        item.routes
      )
      const isNeedToRequestFeedback = feedbackNeededPropertiesList
        .filter(home => {
          if (dateOfLastFeedback(home.feedback.feedbackRequested)) return false
          return true
        })
        .map(item => {
          item.feedback.feedbackRequested = new Date()
          return item
        })

      const data = { homes: isNeedToRequestFeedback, _id: item._id }

      this.generatedTableData = this.generateFeedbackData(this.tableData)
      this.$emit('request-feedback', data)
    }
  }
}
</script>

<style lang="sass" scoped>
/* Disables row hover color change */
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row)
  background-color: $hwayzBackgroundColor

.theme--light.v-table tbody tr:not(:last-child)
  border-style: none
</style>
